import { useImperativeHandle } from "react";
import { Accordion, Card } from "react-bootstrap";
import { get, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";
import { ReactComponent as CheckIcon } from "assets/images/icons/Check.svg";
import { ReactComponent as ExclamationIcon } from "assets/images/icons/Exclamation.svg";
import { QuotationFormStepValidationTypes, QuotationFormStepTypes } from "constants/";
import { IQuotationData } from "pages/provider/QuotationDetail/QuotationType";
import PickupDelivery from "./PickupDelivery";
import { QuotationFormState } from "../../QuotationFormState";

type ScheduleFormProps = {
  childRef: React.MutableRefObject<any>;
  quoteRequestDetails: IQuotationData;
  state: QuotationFormState;
  isMultiStop?: boolean;
};

export default function ScheduleForm({ childRef, quoteRequestDetails, state, isMultiStop }: ScheduleFormProps) {
  const {
    formState: { errors },
  } = useFormContext();
  const [searchParams] = useSearchParams();

  const currentActiveStep = searchParams.get("active_step");
  const scheduleFields = (QuotationFormStepValidationTypes[QuotationFormStepTypes.SCHEDULE] ?? []) as string[];
  const hasError = scheduleFields.some((item) => get(errors, item));
  const multiStopInstructions = quoteRequestDetails?.schedule?.multistop_instructions;

  useImperativeHandle(childRef, () => ({ checkStepValidation }));

  const checkStepValidation = () => {};

  return (
    <Card className="mb-3 form-container">
      <Accordion.Toggle as={Card.Header} className="accordion-header" eventKey={QuotationFormStepTypes.SCHEDULE}>
        <div className="d-flex align-items-center">
          {(hasError || state.draftSaved[QuotationFormStepTypes.SCHEDULE]) && (
            <div className={`valid-status ${hasError ? "error" : ""}`}>{hasError ? <ExclamationIcon /> : <CheckIcon />}</div>
          )}
          <h5>
            <FormattedMessage id="quote-request-detail.schedule" defaultMessage="Schedule" />
          </h5>
        </div>
        <SortIcon
          fill="#000"
          width={8}
          height={7}
          transform={`rotate(${currentActiveStep === QuotationFormStepTypes.SCHEDULE ? 180 : 0})`}
        />
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={QuotationFormStepTypes.SCHEDULE}>
        <Card.Body>
          {multiStopInstructions && (
            <>
              <div className="text-secondary-v2 font-medium text-sm mb-xs">
                <FormattedMessage
                  id="new-request.schedule.multistop.multistopInstructions"
                  defaultMessage="Multi-stop instructions"
                />
              </div>
              <div className="text-primary text-sm py-lg px-xl mb-3xl multi-stop-instructions">{multiStopInstructions}</div>
            </>
          )}
          <PickupDelivery quoteRequestDetails={quoteRequestDetails} isMultiStop={isMultiStop} />
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
